/* eslint-disable */
<template>
  <div class="pale-bg py-5 hero">
    <div class="pt-0 mt-0 pt-lg-5 mt-md-5 position-relative">
      <h1
        class="pl-0 pl-md-4 name-big-text"
        data-aos="fade-up"
        data-aos-duration="800"
        data-text="David Aji"
      >
        David Aji
      </h1>
      <div class="profile">
        <img
          src="https://res.cloudinary.com/ajiva/image/upload/v1581695378/portfolio/David-aji-website-grade.jpg"
          alt="David Aji aka Ajiva"
          class="red-shadow"
        />
        <div class="cover"></div>
      </div>
    </div>
    <div
      class="d-flex justify-content-between align-items-center position-relative mt-5 mt-md-0"
      data-aos="fade-up"
      data-aos-duration="3000"
      data-aos-offset="-500"
    >
      <h2 class="ml-0 pl-0 pl-md-5 ml-md-5 mt-md-4">
        is a <span class="red-text">Front End Developer</span> and
        <span class="red-text">Technical Writer</span> with experience using
        frameworks like Vue
        <span class="vue-logo">
          <img src="../assets/svgs/vue-logo.svg" alt="" />
        </span>
        and React
        <span class="react-logo">
          <img src="../assets/svgs/react-logo.svg" alt="" />
        </span>
        to build highly performant and beautiful JavaScript apps.
      </h2>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        class="message-icon"
        width="40"
        height="36"
        viewBox="0 0 66 36"
      >
        <g fill="none" stroke="#13120d" stroke-width="3" id="msg-g">
          <rect width="66" height="36" stroke="none" />
          <rect x="1.5" y="1.5" width="63" height="33" fill="none" />
        </g>
        <path
          d="M1805.865,947.306l31.433,20.845,30.622-20.845"
          transform="translate(-1803.81 -944.989)"
          fill="none"
          stroke="#13120d"
          stroke-width="3"
          id="msg-r"
        />
      </svg>
    </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState(["siteLoaded"])
  },
  methods: {
    profileReveal() {
      let profileTL = gsap.timeline();
      profileTL
        .from(".profile img", { width: 0, opacity: 0 })
        .to(".profile img", { width: "100%", opacity: 1, duration: 0.5 });
      // profileTL.from('.profile img', 1, { scaleX: 0, transformOrigin: "left", opacity:0 });
      // profileTL.to('.profile img', 1, { scaleX: 0, transformOrigin: "right", opacity:1 });
    }
  },
  watch: {
    siteLoaded(newValue) {
      if (newValue) {
        this.profileReveal();
      }
    }
  }
};
</script>

<style scoped lang="scss">
.name-big-text {
  position: relative;
}
.name-big-text::before,
.name-big-text::after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.name-big-text:hover.name-big-text::before {
  content: attr(data-text);

  left: 2px;
  text-shadow: -1px 0 red;

  /* important: opaque background masks the original */
  background-color: #efeeeb;
  animation: name duration timing-function delay iteration-count direction
    fill-mode;
  animation: glitch-anim1 5s ease-in-out 0.1s infinite alternate,
    textflicker 1s infinite linear alternate-reverse;
}
.name-big-text:hover.name-big-text::after {
  content: attr(data-text);
  left: 2px;
  text-shadow: -1px 0 red;

  /* important: opaque background masks the original */
  background-color: #efeeeb;
  animation: glitch-anim2 2s ease-in-out 0.1s infinite alternate,
    textflicker 1s infinite linear alternate-reverse;
}
@keyframes textflicker {
  from {
    text-shadow: 1px 0 0 #ea36af, -2px 0 0 #75fa69;
  }
  to {
    text-shadow: 2px 0.5px 2px #ea36af, -1px -0.5px 2px #75fa69;
  }
}

@keyframes glitch-anim1 {
  0% {
    clip-path: inset(40% 0 61% 0);
  }
  10% {
    clip-path: inset(92% 0 1% 0);
    content: "大卫·阿吉";
  }
  20% {
    clip-path: inset(43% 0 1% 0);
    content: "Дэвид Аджи";
  }
  25% {
    clip-path: inset(32% 0 13% 0);
    content: attr(data-text);
  }
  30% {
    clip-path: inset(75% 0 8% 0);
    content: "大卫·阿吉";
  }
  35% {
    clip-path: inset(92% 0 1% 0);
    content: "Дэвид Аджи";
  }
  40% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  45% {
    clip-path: inset(25% 0 58% 0);
    content: "大卫·阿吉";
  }
  50% {
    clip-path: inset(15% 0 90% 0);
    content: "Дэвид Аджи";
  }
  52% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  55% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  60% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  62% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  65% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  67% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  70% {
    clip-path: inset(25% 0 63% 0);
    content: "大卫·阿吉";
  }
  80% {
    clip-path: inset(54% 0 7% 0);
    content: "Дэвид Аджи";
  }
  85% {
    clip-path: inset(92% 0 1% 0);
    content: "大卫·阿吉";
  }
  90% {
    clip-path: inset(20% 0 1% 0);
    content: "大卫·阿吉";
  }
  100% {
    clip-path: inset(58% 0 43% 0);
    content: attr(data-text);
  }
}
@keyframes glitch-anim2 {
  0% {
    clip-path: inset(40% 0 61% 0);
  }
  10% {
    clip-path: inset(92% 0 1% 0);
    content: "大卫·阿吉";
  }
  20% {
    clip-path: inset(43% 0 1% 0);
    content: "Дэвид Аджи";
  }
  25% {
    clip-path: inset(32% 0 13% 0);
    content: attr(data-text);
  }
  30% {
    clip-path: inset(75% 0 8% 0);
    content: "大卫·阿吉";
  }
  35% {
    clip-path: inset(92% 0 1% 0);
    content: "Дэвид Аджи";
  }
  40% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  45% {
    clip-path: inset(25% 0 58% 0);
    content: "大卫·阿吉";
  }
  50% {
    clip-path: inset(15% 0 90% 0);
    content: "Дэвид Аджи";
  }
  52% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  55% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  60% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  62% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  65% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  67% {
    clip-path: inset(0 0 0 0);
    content: attr(data-text);
  }
  70% {
    clip-path: inset(25% 0 63% 0);
    content: "大卫·阿吉";
  }
  80% {
    clip-path: inset(54% 0 7% 0);
    content: "Дэвид Аджи";
  }
  85% {
    clip-path: inset(92% 0 1% 0);
    content: "大卫·阿吉";
  }
  90% {
    clip-path: inset(20% 0 1% 0);
    content: "大卫·阿吉";
  }
  100% {
    clip-path: inset(58% 0 43% 0);
    content: attr(data-text);
  }
}

.profile {
  position: absolute;
  right: 0;
  top: -30%;
  width: 40rem;
  height: 390px;
  img {
    position: absolute;
    /* width: 40rem; */
    height: 390px;
    object-fit: cover;
    object-position: 0 -158px;
    filter: invert(100%);
    z-index: 2;
    /* opacity: 0.95; */
    transition: all 0.5s ease-in-out;
    &:hover {
      z-index: 4;
      transition: all 0.8s ease-in-out;
      filter: invert(0);
      height: 420px;
      transform: skew(1deg, 1deg);
    }
  }
  .cover {
    position: absolute;
    width: 100%;
    height: 100%;
    background-color: #efeeeb;
  }
}
.profile:before,
.profile:after {
  clip: rect(0px, 0px, 0px, 0px);
}
/* .profile */
h1 {
  mix-blend-mode: difference;
  z-index: 3;
  position: relative;
  filter: invert(1);
  display: inline-block;
  width: 1000px;
}
h1:hover {
  mix-blend-mode: darken;
  filter: invert(0);
}
/* h1:hover ~ .profile{
	mix-blend-mode: luminosity;
} */
h2 {
  max-width: 1050px;
}
.message-icon {
  bottom: 10vh;
  right: 4vw;
  position: fixed;
  transition: all 0.2s ease-in;
}
.message-icon:hover #msg-g,
.message-icon:hover #msg-r {
  stroke: #8d140e;
}
.message-icon:hover {
  transform: scale(1.2);
  transition: all 0.3s ease-in;
}
.vue-logo,
.react-logo {
  position: relative;
}
.vue-logo img,
.react-logo img {
  width: 40px;
  position: absolute;
  left: -44px;
}
.vue-logo img {
  animation: bouncein 7s ease-in-out 0.1s infinite;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
  -webkit-animation-direction: alternate;
  animation-direction: alternate;
}
.react-logo img {
  animation: bounceout 7s ease-in-out 0.1s infinite;
  -webkit-animation-fill-mode: backwards;
  animation-fill-mode: backwards;
  -webkit-animation-direction: alternate;
  animation-direction: alternate;
}

@keyframes bouncein {
  from {
    transform: translateY(-50%);
  }
  to {
    transform: translateY(100%);
  }
}

@keyframes bounceout {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(-50%);
  }
}

@media only screen and (max-width: 767px) {
  h1 {
    width: 100%;
  }
  .profile {
    top: 90px;
    width: 15rem;
    height: 15rem;
    object-fit: cover;
    object-position: 0;
  }
  svg,
  rect {
    align-self: flex-end;
    margin-bottom: 40px;
  }
  svg {
    position: absolute;
    right: 15px;
  }
  .message-icon {
    bottom: 3vh;
    right: 15px;
    position: fixed;
  }
}
@media only screen and (min-width: 768px) and (max-width: 999px) {
  .profile {
    top: -60%;
    width: 18rem;
    height: 10rem;
    object-fit: cover;
    object-position: 0;
  }
}
@media only screen and (min-width: 2000px) {
  .hero {
    max-width: 1140px;
    margin: auto;
  }
}
</style>
